import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, CardFooter, CardText, Col, Row } from 'reactstrap';
import { auth } from "../../firebase/firebase-config";
import firebase from "../../firebase/firebase-config";
import { useAuthState } from 'react-firebase-hooks/auth';
import 'react-toastify/dist/ReactToastify.css';
import { toast, Toast, ToastContainer } from 'react-toastify';
import BankCard from './specificBankCard';

const VerifyBankPage = ({ data }) => {
    const [Currentuser, loading] = useAuthState(auth);
    const [bankDetails, SetBankDetails] = useState([]);
    const [pendignbank, setPendingbank] = useState([])
    const [verifiedbank, setverifiedbank] = useState([])
    const [declinedbank, setdeclinedbank] = useState([])


    const [query, setquery] = useState('')
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };


    useEffect(() => {

        getBankDetails();




    }, [])


    async function getBankDetails() {
        var BankVerifyDetails = []
        await firebase.firestore().collection('bankDetails').onSnapshot((snapdata) => {

            snapdata.docs.forEach((snap) => {
                BankVerifyDetails.push(snap.data());
            })
            SetBankDetails(BankVerifyDetails);


        })
        firebase.firestore().collection('bankDetails').where('verificationStatus', '==', 'Pending').onSnapshot((order) => {
            const Pendingbank_data = [];
            order.forEach(element => {
                Pendingbank_data.push(element.data());
            });
            setPendingbank(Pendingbank_data);

        })
        firebase.firestore().collection('bankDetails').where('verificationStatus', '==', 'verified').onSnapshot((order) => {
            const verifiedbank_data = [];
            order.forEach(element => {
                verifiedbank_data.push(element.data());
            });
            // console.log(Approvedorders_data);
            setverifiedbank(verifiedbank_data);

        })
        firebase.firestore().collection('bankDetails').where('verificationStatus', '==', 'declined').onSnapshot((order) => {
            const declinedbank_data = [];
            order.forEach(element => {
                declinedbank_data.push(element.data());
            });
            // console.log(Approvedorders_data);
            setdeclinedbank(declinedbank_data);

        })
    }

    useEffect(() => {
        // firebase.firestore().collection('orders').where('userId', '==', data?.id).where('isCompleted', '==', true).where('status', '==', 'delivered').get().then((snapdata) => {
        //     var total_amount = [];
        //     // console.log(snapdata);
        //     snapdata.forEach((order_amount) => {
        //         total_amount.push(order_amount.data()['amount']);

        //     })
        //     console.log(total_amount);
        //     const result = total_amount.reduce((a, v) => a = a + v, 0)
        //     console.log(result);

        //     settotal_orders_earnings(result);
        // })
        // var orders_delivered = [];
        // firebase.firestore().collection('orders').where('userId', '==', data?.id).where('status', '==', 'delivered').onSnapshot((snapdata) => {
        //     snapdata.forEach((order) => {
        //         orders_delivered.push(order.data());
        //     })
        //     settotal_orders_delivered(orders_delivered);
        // })



    }, [])

    return (
        <>
            <div className="content">
                <Row>
                    <Col xs="12">

                        <div className="row  d-flex justify-content-center align-items-center">

                            <div className="col-md-6">

                                <div className="form" style={{ position: 'relative' }}>
                                    {query == '' ? <i className="fa fa-search" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i> : <i className="fa fa-close" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i>}

                                    <input type="text" className="form-control form-input" placeholder="Search any Order..." value={query} onChange={(e) => setquery(e.target.value)} style={{
                                        height: '55px',
                                        textIndent: '33px',
                                        borderRadius: '10px'
                                    }} />
                                    <span className="left-pan" style={{
                                        position: 'absolute',
                                        right: '17px',
                                        top: '13px',
                                        padding: '2px',
                                        borderLeft: '1px solid #d1d5db',
                                    }}>
                                        {query == '' ?
                                            <i className="fa fa-microphone" style={{ paddingLeft: '10px' }}></i> : <i className="fa fa-search" style={{ paddingLeft: '10px' }}></i>}</span>

                                </div>

                            </div>

                        </div>


                    </Col>
                </Row>
                <Row className="d-flex justify-content-center  mt-4 align-items-center">
                    <button
                        className={toggleState === 1 ? "tabs active-tabs btn btn-primary btn-sm" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(1)}
                    >
                        Total Bank Accounts Verifications
                        ({bankDetails.length})
                    </button>
                    <button
                        className={toggleState === 2 ? "tabs active-tabs btn btn-sm btn-primary" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(2)}
                    >
                        Pending({pendignbank.length})
                    </button>

                    <button
                        className={toggleState === 3 ? "tabs active-tabs btn btn-sm btn-primary" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(3)}
                    >
                        Verified({verifiedbank.length})
                    </button>
                    <button
                        className={toggleState === 4 ? "tabs active-tabs btn-sm btn btn-primary" : "tabs btn btn-sm btn-default"}
                        onClick={() => toggleTab(4)}
                    >
                        Declined({declinedbank.length})
                    </button>

                </Row>
                <div className='mt-4'>
                    <div className="content-tabs">
                        <div className={toggleState === 1 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {bankDetails.filter(bank => bank.accountNumber.toLowerCase().includes(query)).map((order, i) => (

                                    <BankCard data={order} key={i} />
                                    // <OrderCard data={order} key={i} />


                                ))}
                            </div>



                        </div>
                        <div className={toggleState === 2 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {pendignbank.filter(bank => bank.accountNumber.toLowerCase().includes(query)).map((order, i) => (

                                    <BankCard data={order} key={i} />
                                    // <OrderCard data={order} key={i} />


                                ))}
                            </div>



                        </div>
                        <div className={toggleState === 3 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {verifiedbank.filter(bank => bank.accountNumber.toLowerCase().includes(query)).map((order, i) => (

                                    <BankCard data={order} key={i} />
                                    // <OrderCard data={order} key={i} />


                                ))}
                            </div>



                        </div>
                        <div className={toggleState === 4 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {declinedbank.filter(bank => bank.accountNumber.toLowerCase().includes(query)).map((order, i) => (

                                    <BankCard data={order} key={i} />
                                    // <OrderCard data={order} key={i} />


                                ))}
                            </div>



                        </div>
                        {/* <div className={toggleState === 2 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_pendingorders.filter(order => order.orderId.toLowerCase().includes(query)).map((order, i) => (


                                    <OrderCard data={order} key={i} />


                                ))}
                            </div>
                        </div>
                        <div className={toggleState === 3 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_Approvedorders.filter(order => order.orderId.toLowerCase().includes(query)).map((order, i) => (


                                    <OrderCard data={order} key={i} />


                                ))}
                            </div>
                        </div>
                        <div className={toggleState === 4 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_Productionorders.filter(order => order.orderId.toLowerCase().includes(query)).map((order, i) => (


                                    <OrderCard data={order} key={i} />


                                ))}
                            </div>
                        </div>
                        <div className={toggleState === 5 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_OFDorders.filter(order => order.orderId.toLowerCase().includes(query)).map((order, i) => (


                                    <OrderCard data={order} key={i} />


                                ))}
                            </div>
                        </div>
                        <div className={toggleState === 6 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_Deliveredorders.filter(order => order.orderId.toLowerCase().includes(query)).map((order, i) => (


                                    <OrderCard data={order} key={i} />


                                ))}
                            </div>
                        </div> */}
                    </div>

                </div>

            </div>

        </>
    )
}


export default VerifyBankPage;